document.addEventListener('DOMContentLoaded', () => {

  // Helper function to format a number with thousand separators and 2 decimals
  function formatPrice(amount) {
    return `$${amount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
  }

  // Grab the product form
  // There are two product forms (main and main-payment-installment)
  // Pick the correct main form (ID ends with __main)
  const productForm = document.querySelector('form.shopify-product-form[id$="__main"]');

  // Grab the dynamic price element
  const dynamicPriceTextEl = document.getElementById('dynamic-price-text');
  const totalPriceTextEl = document.getElementById('total-price-text');
  const totalCompareTextEl = document.getElementById('total-compare-at-text');
  const saveEl = document.getElementById('total-save-text');

  //
  const quantityInput = document.querySelector('input[name="quantity"]');

  if (!productForm || !totalCompareTextEl || !totalPriceTextEl || !quantityInput) return;

   // Read initial price from data attributes
  let variantPriceCents = parseInt(dynamicPriceTextEl.dataset.price) || 0;
  let comparePriceCents = parseInt(dynamicPriceTextEl.dataset.compare) || 0;

  // Function to update the price based on variant and quantity
  function updateDynamicPrice(variant, quantity = 1) {
    
    if (!variant) {
      return;
    }

    const quantityInput = document.querySelector('input[name="quantity"]');
        if (!quantityInput) return;

    quantity = parseInt(quantity) || parseInt(quantityInput.value) || 1;

    // Store variant prices
    variantPriceCents = variant.price;
    comparePriceCents = variant.compare_at_price || 0;

    // Calculate totals
    const totalPrice = (variantPriceCents * quantity) / 100;
    const compareTotal = (comparePriceCents > variantPriceCents ? (comparePriceCents * quantity) / 100 : 0);
    const saveAmount = compareTotal - totalPrice;

    // Update DOM elements

    // Current price
    if (totalPriceTextEl) {
      totalPriceTextEl.textContent = formatPrice(totalPrice);
    }

    // Compare-at price
    if (totalCompareTextEl) {
        totalCompareTextEl.textContent = compareTotal > 0 ? formatPrice(compareTotal) : '';
    }

    // Save amount
    if (saveEl) {
        saveEl.textContent = saveAmount > 0 ? `Save ${formatPrice(saveAmount)}` : '';
    }

    //update paypal pay in 4
    const payin4El = document.getElementById('paypal-payment');
    if (totalPrice < 2000){
       let installment = (totalPrice / 4);
       payin4El.textContent = `Pay in 4 interest-free payments of $${installment} via PayPal*.`;
    } else {
       payin4El.textContent = "Pay in 4 interest-free payments is available on purchases under $2,000 via PayPal*.";
    }

    //Update the More Info Link
    const link = document.getElementById('payment-link');
    if (link) link.href = `?total=${totalPrice.toFixed(2)}`;

    //End of paypal update

  } // End of updateDynamicPrice

  // Listen to Shopify variant change event
  productForm.addEventListener('variant:change', (e) => {
    const quantityInput = document.querySelector('input[name="quantity"]');
            if (!quantityInput) return;
    const qty = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
    if (e.detail && e.detail.variant) {
      updateDynamicPrice(e.detail.variant, qty);
    }
  });

  // Listen to quantity changes
    document.addEventListener('input', (e) => {
        if (e.target.matches('input[name="quantity"]')) {
        const qty = parseInt(e.target.value) || 1;
        updateDynamicPrice({ price: variantPriceCents, compare_at_price: comparePriceCents }, qty);
        }
    });
    document.addEventListener('change', (e) => {
        if (e.target.matches('input[name="quantity"]')) {
            const qty = parseInt(e.target.value) || 1;
            updateDynamicPrice({ price: variantPriceCents, compare_at_price: comparePriceCents }, qty);
        }
    });
  
});
